type BenefitItem = {
    highlight: string
    text: string
    highlightClass?: string
    textClass?: string
}

type Props = {
    icon: string
    title: string
    benefits: BenefitItem[]
    className?: string      
    textAlign?: "left" | "center" | "right"
}
    
    const BenefitCard = ({ icon, title, benefits, className="", textAlign = "center" }: Props) => {
        return (
        <div className={`benefit-card content-two-card ${className}`}>
            <img src={icon} alt={title} className='benefit-icon' />
            <h3>{title}</h3>
            <div className={`benefits-container content-two-text text-${textAlign}`}>
            {benefits.map((b, i) => (
                <div key={i} className="benefit-item content-two-item">
                <span className={`benefit-text ${b.highlightClass ?? ''}`}>{b.highlight}</span>
                <span className={`benefit-subtext ${b.textClass ?? ''}`}>{b.text}</span>
                </div>
            ))}
            </div>
        </div>
        )
    }

export default BenefitCard
